export const STICKER_PACKS = 'STICKER_PACKS';
export const SKINS = 'SKINS';
